import { useEffect, useState } from 'react';
import { Socket } from 'socket.io-client';
import { createFeedGatewayClient } from '../utils/spl-factory-backend/feed';

export const useFeedGeteway = () => {
    const [feedGetewayClient, setFeedGetewayClient] = useState<Socket>();

    useEffect(() => {
        const feedSocket = createFeedGatewayClient(process.env.REACT_APP_MINT_TS_BACKEND!, process.env.REACT_APP_MINT_TS_BACKEND_APIKEY!);

        feedSocket.on('connect', () => console.debug('Automatization client connected', feedSocket.id));
        feedSocket.on('connect_error', () => console.debug('Automatization client connection error'));
        feedSocket.on('disconnect', () => console.debug('Automatization client disconnected'));

        feedSocket.connect();

        setFeedGetewayClient(feedSocket);

        return () => {
            feedSocket.off('connect');
            feedSocket.off('connect_error');
            feedSocket.off('disconnect');
            feedSocket.disconnect();
        };
    }, []);

    return {
        feedGetewayClient,
    };
};
